/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOpenFolder = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.535 5H20v3h1.388l-1.001 3h2l-3.666 11H2V2h8.535zM4.387 20h12.892l2.334-7H6.721zM4 14.839 6.28 8H18V7h-6.535l-2-3H4zM7.387 11h10.892l.334-1H7.721z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOpenFolder as OpenFolder };
